import { useMutation } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

interface CreatePortalSessionParams {
  returnUrl: string
}

export function useStripePortal() {
  return useMutation({
    mutationFn: async (params: CreatePortalSessionParams) => {
      const {
        data: { session },
      } = await supabase.auth.getSession()

      if (!session?.access_token) {
        throw new Error('No session found')
      }

      const response = await fetch(
        `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/create-portal-session`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${session.access_token}`,
          },
          body: JSON.stringify({
            returnUrl: params.returnUrl,
          }),
        }
      )

      if (!response.ok) {
        const error = await response.json()
        throw new Error(error.error || 'Failed to create portal session')
      }

      const data = await response.json()
      // Redirect to Stripe portal
      window.location.href = data.url
      return data
    },
  })
}
